export const EntityExtraTagsRequestRules = {
  ChatMessagesCount: 'chat_messages_count',
  DocFlowsCount: 'document_staplings_count',
  EmailsCount: 'thread_emails_count',
  ErrorMessagesCount: 'error_messages_count',
  FilesCount: 'files_count',
  HasActivities: 'has_activities',
  HasContractors: 'has_contractors',
  HasInvoices: 'has_invoices',
  HasOrders: 'has_orders',
  OpenTasksCount: 'open_tasks_count',
  RelatedRequestsCount: 'related_requests_count',
  UnreadChatMessagesCount: 'unread_chat_messages_count',
  UnreadEmailsCount: 'unread_emails_count',
}

export const EntityExtraTagsTaskRules = {
  ActiveAutomationsCount: 'active_automations',
  EmailsCount: 'threads',
  ErrorMessagesCount: 'error_messages',
  FilesCount: 'files',
  UnreadEmailsCount: 'unread_threads',
}

export const EntityExtraTagsInvoiceRules = {
  FilesCount: 'files_count',
}

export const EntityExtraTagsDocFlowRules = {
  EmailsCount: 'emails_count',
  EpostCount: 'epost_count',
  ErrorEpostCount: 'epost_errors_count',
  ErrorMessagesCount: 'email_errors_count',
}

export const ENTITY_EXTRA_TAGS_RATING_AVG = 'rating_avg'

export const QA_NAME_ENTITY_EXTRA_TAGS_EMAIL = 'email'

export const QA_NAME_ENTITY_EXTRA_TAGS_MESSAGE = 'message'

export const QA_NAME_ENTITY_EXTRA_TAGS_TASK = 'task'

export const QA_NAME_ENTITY_EXTRA_TAGS_INVOICE = 'invoice'

export const QA_NAME_ENTITY_EXTRA_TAGS_CONTRACTOR = 'contractor'

export const QA_NAME_ENTITY_EXTRA_TAGS_ORDER = 'order'

export const QA_NAME_ENTITY_EXTRA_TAGS_FILES = 'attach'

export const QA_NAME_ENTITY_EXTRA_TAGS_RELATED = 'related'

export const QA_NAME_ENTITY_EXTRA_TAGS_DOC_FLOW = 'docFlow'

export const QA_NAME_ENTITY_EXTRA_TAGS_AUTOMATION = 'automation'

export const QA_NAME_ENTITY_EXTRA_TAGS_EPOST = 'epost'
